import { GrowerProgramsAPI, ResourceDetail } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'

export const useBenchmarkTest = (details?: ResourceDetail[]) =>
  useQuery(
    ['benchmark-test', JSON.stringify(details)],
    () =>
      details && GrowerProgramsAPI.testRules(details).then(response => response?.programStatuses),
    {
      enabled: !!details?.length,
      keepPreviousData: true,
    }
  )
